import { select, DisposalSet, selectAll } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

const gc = new DisposalSet();

const FOCUS_OUT_DELAY = 150;
const STATE_TOGGLE_TIMEOUT = 300;

registerFragment('cbdce-profile-selection-menu', (fragmentElement, configuration, meta) => {
    gc.disposeAll();

    const isEditMode = document.body.classList.contains('has-edit-mode-menu');

    const navItemEls = selectAll<HTMLDivElement>(fragmentElement, '.cbdce-header-nav-item');
    navItemEls.forEach(navItemEl => {
        if(navItemEl.querySelector('.cbdce-header-nav-item__submenu')) {
            const submenuEl = select<HTMLDivElement>(navItemEl, '.cbdce-header-nav-item__submenu');
            const toggleEl = select<HTMLButtonElement>(navItemEl, '.cbdce-header-nav-item__toggle');
            (gc.register(toggleEl)
                .addListener('click', (e) => {
                    navItemEl.classList.toggle('cbdce-header-nav-item--open');
                    if(toggleEl.getAttribute('aria-expanded') == 'true') {
                        toggleEl.setAttribute('aria-expanded', 'false');
                    } else {
                        toggleEl.setAttribute('aria-expanded', 'true');
                    }
                })
            );

        };
    });

    const profileSelectionMenus = selectAll<HTMLDivElement>(fragmentElement, '.cbdce-profile-selection-menu');
    profileSelectionMenus.forEach(profileSelectionMenu => {
        const toggleEl = select<HTMLButtonElement>(profileSelectionMenu, '.cbdce-profile-selection-menu__toggle-button');

        (gc.register(toggleEl)
            .addListener('click', (e) => {
                if(toggleEl.getAttribute('aria-expanded') == 'true') {
                    toggleEl.setAttribute('aria-expanded', 'false');
                    toggleEl.innerText = 'Expand Menu';
                } else {
                    toggleEl.setAttribute('aria-expanded', 'true');
                    toggleEl.innerText = 'Collapse Menu';
                }
            })
        );
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => {
        gc.disposeAll();
    });
}
